import { render, staticRenderFns } from "./QuestionAndAnswerSetting.vue?vue&type=template&id=0505b11f&"
import script from "./QuestionAndAnswerSetting.vue?vue&type=script&lang=js&"
export * from "./QuestionAndAnswerSetting.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAndAnswerSetting.vue?vue&type=style&index=0&id=0505b11f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports